<template>
  <div class="order-list">


    <div class="action-toolbar">


    </div>


    <el-card class="table-card" style="margin-top: 16px; overflow-x: auto;">
      <el-table :data="tableData" @sort-change="handleSortChange" border  style="width: 100%" v-loading="loading" show-overflow-tooltip
                :cell-style="{whiteSpace: 'nowrap'}"
                :header-cell-style="{whiteSpace: 'nowrap'}"
      >
        <el-table-column :label="$t('showNewsManage.news_title')">
          <template #default="{ row }">

            <a href="#" @click.prevent="openNewsDialog(row)" style="text-decoration: none; color: #409EFF;">
      <span v-if="row.flag === 0" style="color: red;">
        ({{ $t('showNewsManage.unread') }})
      </span>
              {{ $i18n.locale === 'en-US' ? row.newsTitleEn : row.newsTitleCn }}
            </a>
          </template>
        </el-table-column>

        <el-table-column prop="newsSendTime" :label="$t('showNewsManage.send_time')" ></el-table-column>



      </el-table>


      <!-- 详情弹窗 -->
      <el-dialog
        :title="$t('showNewsManage.news_details')"
        :visible.sync="dialogVisible"
        width="50%"
      >
        <div style="line-height: 1.8;">


          <div
            style="font-size: 15px; color: #303133;"
            v-html="
          $i18n.locale === 'en-US'
            ? currentNews.newsContentEn
            : currentNews.newsContentCn
  "
          ></div>

          <el-divider></el-divider>

          <div style="margin-bottom: 15px; color: #909399;">
            <strong>{{ $t('showNewsManage.send_time') }}:</strong> {{currentNews.newsSendTime }}
          </div>


        </div>


        <template #footer>
    <span class="dialog-footer">

      <el-button @click="dialogVisible = false">
        {{ $t('showNewsManage.cancel') }}
      </el-button>

      <el-button
        v-if="currentNews.flag === 0"
        type="primary"
        :loading="updateLoading"
        @click="handleMarkAsRead"
      >
  {{ $t('showNewsManage.read') }}
</el-button>
    </span>
        </template>
      </el-dialog>




      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 16px; text-align: right;"
      />






    </el-card>




  </div>





</template>

<script>
import { hasPermission } from "@/utils/permission";
export default {
  name: "OrderList",
  data() {
    return {

      // 控制弹窗的显示与隐藏
      dialogVisible: false,
      currentNews: {},

      loading: false,
      News: {
        startDate: "",
        endDate: "",
        hkbatchNo: "",

        sortField: undefined,
        sortOrder: undefined
      },



      updateLoading: false,
      tableData: [],

      columnWidths:{},
      pagination: {
        page: 1,
        limit: 10,
        total: 0,
      },
      pages:"",

    };
  },
  created() {
     this.handleSearch(); // 初始化加载数据
  },
  mounted() {
    this.$nextTick(() => {
      this.initColumnWidths();
    });
  },
  // 发送变化重新计算
  computed:{

  },
  methods: {
    // 按钮
    hasPermission,
    // 排序
    handleSortChange({ column, prop, order }) {
      // prop 是排序的字段名 (例如 'tsId')
      // order 是排序方式：'ascending' (升序), 'descending' (降序), 或者 null (默认不排序)
      if (order === null) {
        this.News.sortField = undefined;
        this.News.sortOrder = undefined;
      } else {
        // 正常赋值升序或降序
        this.News.sortField = prop;
        this.News.sortOrder = order;
      }
      // 重新调用获取列表的接口
      this.fetchOrderList();
    },
    // 数据绑定
    handleRadioChange(row) {
      this.selectedRowData = row;
    },


    // 查询
    handleSearch() {
      this.pagination.page = 1; // 重置页码
      this.fetchOrderList();
    },
    // 重置
    handleReset() {
      this.$refs.queryForm.resetFields();

      this.hasSearched = false;
      //this.handleSearch();
    },
    //
    async fetchOrderList() {
      this.loading = true;
      try {
        const params = {
          mbaBankaccount: this.News.mbaBankaccount || undefined,
          mbaStatus: this.News.mbaStatus || undefined,

          sortField: this.News.sortField || undefined,
          sortOrder: this.News.sortOrder || undefined,

          page: this.pagination.page,
          limit: this.pagination.limit,
        };

        const res = await this.$axios.post('/api/news/merlist',  params );

        if (res.data.code === 0) {
          const responseData = res.data.data;

          this.tableData = responseData.records || [];

          this.pagination.total = Number(responseData.total) || 0;
          this.pagination.page = Number(responseData.current) || this.pagination.page;
          this.pagination.limit = Number(responseData.size) || this.pagination.limit;

          if (this.pagination.total > 0) {
            this.hasSearched = true;
          }
        } else {
          this.$message.error(res.data.msg);
          this.tableData = [];
          this.pagination.total = 0;
        }
      } catch (err) {
        console.error('查询订单失败:', err);
        this.$message.error('网络错误，请稍后重试');
        this.tableData = [];
        this.pagination.total = 0;
      } finally {
        this.loading = false;
      }
    },
    // 打开弹窗
    openNewsDialog(row) {
      this.currentNews = row; // 将当前行数据赋值给弹窗绑定的变量
      this.dialogVisible = true; // 打开弹窗
    },

    // 已读功能
    async handleMarkAsRead(){

      this.updateLoading = true;

      const res = await this.$axios.put(
        `/api/news/readNews/${this.currentNews.newsId}`
      );
      if (res.data.code === 0) {

        this.currentNews.flag = 1;

        this.$message.success(this.$t('succeed'));

        this.dialogVisible = false;

      } else {

        this.$message.error(res.data.msg || '操作失败');

      }

    },

    // 分页：每页条数变化
    handleSizeChange(val) {
      this.pagination.limit = val;
      this.pagination.page = 1; //
      this.fetchOrderList(); //
    },
    // 分页：当前页变化
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.fetchOrderList(); //
    },
    // 处理选择id
    handleRowClick(row) {
      this.selectedRowId = row.tsId;

    },



  },
};
</script>

<style>
/* 全局样式 - 表头居中 */
.el-table th .cell {
  white-space: nowrap !important;
  text-align: center !important;
}

.el-table .cell {
  white-space: nowrap !important;
  text-align: center !important;
}
</style>

<style scoped>
.order-list {
  padding: 20px;
}

/* 确保输入框、下拉框、时间选择器在栅格中占满 100% 宽度 */
.full-width {
  width: 100% !important;
}

/* 使用 Flex 布局优雅处理 输入框 + More 按钮 的组合 */
.input-with-more {
  display: flex;
  align-items: center;
  width: 100%;
}

.input-with-more .el-input {
  flex: 1; /* 让输入框自动撑满剩余空间 */
}

.input-with-more .el-button {
  margin-left: 10px; /* 按钮和输入框之间的间距 */
  flex-shrink: 0; /* 防止按钮被挤压变形 */
}

/* 保持表格原有样式不变 */
.table-card ::v-deep .el-table .cell {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.table-card ::v-deep .el-table th .cell {
  white-space: nowrap !important;
}
.table-card {
  overflow-x: auto;
}

.table-card ::v-deep .el-table {
  min-width: 100%;
}


/* --- 修改 1：美化查询表单的标签字体 --- */
.query-card /deep/ .el-form-item__label {
  white-space: nowrap !important;
  font-weight: 600 !important; /* 强制加粗生效 */
  color: #303133 !important; /* 强制颜色深灰生效 */
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  min-width: 140px;
  text-align: right;
}

/* --- 修改 2：美化输入框内的字体和边框 --- */
.query-card /deep/ .el-input__inner {
  font-weight: 500 !important; /* 强制生效 */
  color: #606266 !important; /* 强制生效 */
  border-radius: 6px !important; /* 强制微圆角生效 */
}
/* 鼠标悬浮时输入框边框颜色加深一点点（可选增亮效果） */
.query-card /deep/ .el-input__inner:hover {
  border-color: #c0c4cc !important;
}

/* 操作工具栏样式 */
.action-toolbar {
  margin-top: 16px;     /* 与上方查询卡片拉开间距 */
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* 按钮之间的间距调整 */
.action-toolbar .el-button {
  margin-left: 10px;
  margin-right: 0;
}

.drawer-form {
  padding-right: 20px;
}

/*侧边弹窗*/
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  padding: 15px 20px;

  border-top: 1px solid #ebeef5;
  background: #fff;

  text-align: right;
}
::v-deep .el-drawer__body {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.drawer-form {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  padding-bottom: 80px;
}
.drawer-footer {
  flex-shrink: 0;
  padding: 15px 20px;
  border-top: 1px solid #ebeef5;
  background: #fff;
  text-align: right;
}

</style>



// WEBPACK FOOTER //
// src/view/mernews/showNewsManage.vue